import React from "react";
import NProgress from "nprogress";
import Headers from "../../../components/Headers";
import { Button, Table, Divider, Modal, message } from "antd";
import { fetchOrderDetails } from "../../../api/earnings";
const { Column } = Table;

const BreadCrumbData = [
  { path: "/page/earnings/earnings", name: "商户" },
  { path: "", name: "商户店铺" },
];
class Details extends React.Component {
  state = {
    list: [],
  };

  async componentDidMount() {
    NProgress.start();
    await this.getList();
    NProgress.done();
  }
  getList = () => {
    fetchOrderDetails(this.props.match.params.id).then((res) => {
      if (res.success) {
        this.setState({
          list: res.data,
        });
      }
    });
  };
  renderResult = (record) => {
    return (
      <div>
        <span>
          {record.shipmentResult
            ? record.shipmentResult === "SUCCESS"
              ? "出货成功"
              : "出货失败"
            : null}
        </span>
        {record.shipmentResult == "FAIL" ? (
          <span>
            ， {record.refundsStatus === "SUCCESS" ? "已退款" : "未退款"}
          </span>
        ) : null}
      </div>
    );
  };
  render() {
    const { list } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="salesData">
          <Button onClick={() => this.props.history.go(-1)}>返回</Button>
        </div>
        <div className="content">
          <Table
            rowKey={(item, index) => index}
            dataSource={list}
            pagination={false}
          >
            <Column
              title="出货时间"
              dataIndex="shipmentTime"
              key="shipmentTime"
            />
            <Column
              title="商品名称"
              dataIndex="materialsName"
              key="materialsName"
            />
            <Column title="销售单价/元" dataIndex="price" key="price" />
            <Column title="出货结果" render={this.renderResult} />
          </Table>
        </div>
      </div>
    );
  }
}
export default Details;
